export async function getSymbolDataAlphaVantage(symbol, api_key, _onSuccess) {
  const url = `https://www.alphavantage.co/query?function=TIME_SERIES_DAILY&symbol=${symbol}&apikey=${api_key}&outputsize=full`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const jsonResponse = await response.text(); // Returns the raw JSON string
    //return jsonResponse;
    _onSuccess(jsonResponse);
  } catch (error) {
    console.error("Request error:", error.message);
    //return error.message;
  }
}
